import React from 'react';
import { NotificationPreferences as NotificationPrefsType } from '../../types/user.types';

interface NotificationPreferencesProps {
  preferences: Partial<NotificationPrefsType>;
  onChange: (preferences: Partial<NotificationPrefsType>) => void;
  disabled?: boolean;
}

export const NotificationPreferences: React.FC<NotificationPreferencesProps> = ({
  preferences,
  onChange,
  disabled = false,
}) => {
  const updatePreference = (key: keyof NotificationPrefsType, value: boolean) => {
    if (disabled) return;
    onChange({ ...preferences, [key]: value });
  };

  return (
    <div className="space-y-4">
      <label className="block text-sm font-medium text-gray-700 mb-3">
        Email Notification Preferences
      </label>

      <div className="space-y-3">
        <div className="flex items-center justify-between p-3 border border-gray-300 rounded-lg">
          <div>
            <div className="text-sm font-medium text-gray-900">
              Customer Registrations
            </div>
            <div className="text-xs text-gray-500">
              Receive email when a new customer registers
            </div>
          </div>
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              checked={preferences.notifyOnCustomerRegistration || false}
              onChange={(e) => updatePreference('notifyOnCustomerRegistration', e.target.checked)}
              disabled={disabled}
              className="sr-only peer"
            />
            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-accent-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-accent-600"></div>
          </label>
        </div>

        <div className="flex items-center justify-between p-3 border border-gray-300 rounded-lg">
          <div>
            <div className="text-sm font-medium text-gray-900">
              Supplier Registrations
            </div>
            <div className="text-xs text-gray-500">
              Receive email when a new supplier registers
            </div>
          </div>
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              checked={preferences.notifyOnSupplierRegistration || false}
              onChange={(e) => updatePreference('notifyOnSupplierRegistration', e.target.checked)}
              disabled={disabled}
              className="sr-only peer"
            />
            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-accent-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-accent-600"></div>
          </label>
        </div>

        <div className="flex items-center justify-between p-3 border border-gray-300 rounded-lg">
          <div>
            <div className="text-sm font-medium text-gray-900">
              Approval Notifications
            </div>
            <div className="text-xs text-gray-500">
              Receive email when registrations are approved
            </div>
          </div>
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              checked={preferences.notifyOnApproval !== false}
              onChange={(e) => updatePreference('notifyOnApproval', e.target.checked)}
              disabled={disabled}
              className="sr-only peer"
            />
            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-accent-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-accent-600"></div>
          </label>
        </div>

        <div className="flex items-center justify-between p-3 border border-gray-300 rounded-lg">
          <div>
            <div className="text-sm font-medium text-gray-900">
              Rejection Notifications
            </div>
            <div className="text-xs text-gray-500">
              Receive email when registrations are rejected
            </div>
          </div>
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              checked={preferences.notifyOnRejection !== false}
              onChange={(e) => updatePreference('notifyOnRejection', e.target.checked)}
              disabled={disabled}
              className="sr-only peer"
            />
            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-accent-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-accent-600"></div>
          </label>
        </div>

        <div className="flex items-center justify-between p-3 border border-gray-300 rounded-lg">
          <div>
            <div className="text-sm font-medium text-gray-900">
              Email Enabled
            </div>
            <div className="text-xs text-gray-500">
              Master switch for all email notifications
            </div>
          </div>
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              checked={preferences.emailEnabled !== false}
              onChange={(e) => updatePreference('emailEnabled', e.target.checked)}
              disabled={disabled}
              className="sr-only peer"
            />
            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-accent-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-accent-600"></div>
          </label>
        </div>
      </div>
    </div>
  );
};
